import {Action} from 'redux'
import {actionTypes} from './constants'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

const initialDisputeState: IDisputeState = {
  data: {
    disputeClaim: [],
    meta: {},
  },
  deleteSuccess: false,
  enableSuccess: false,
  disableSuccess: false,
  singleEnableSuccess: false,
  singleDisableSuccess: false,
  loading: false,
  success: false,
}

export interface IDisputeState {
  data?: {
    disputeClaim?: {[key: string]: number | string}[]
    meta?: {[key: string]: number}
  }
  deleteSuccess?: boolean
  enableSuccess?: boolean
  disableSuccess?: boolean
  singleEnableSuccess?: boolean
  singleDisableSuccess?: boolean
  loading?: boolean
  success?: boolean
}

export const reducer = (
  state: IDisputeState = initialDisputeState,
  action: ActionWithPayload<IDisputeState>
) => {
  switch (action.type) {
    case actionTypes.GET_DISPUTES_START: {
      return {...state, loading: true}
    }

    case actionTypes.GET_DISPUTES_SUCCESS: {
      return {...state, data: action.payload, loading: false}
    }

    case actionTypes.GET_DISPUTES_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    case actionTypes.RESET_APPLY_LOAN: {
      return {
        ...state,
        data: [],
        success: false,
      }
    }

    case actionTypes.DELETE_DISPUTES_START: {
      return {...state, loading: true}
    }

    case actionTypes.DELETE_DISPUTES_SUCCESS: {
      return {
        ...state,
        deleteSuccess: true,
        loading: false,
      }
    }

    case actionTypes.DELETE_DISPUTES_FINISH: {
      return {
        ...state,
        loading: false,
        deleteSuccess: false,
      }
    }

    default:
      return state
  }
}
